var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84339 11.5369C8.45376 12.1544 7.54644 12.1544 7.15682 11.5369L3.35306 5.50874C2.93871 4.85208 3.41496 4 4.19635 4H11.8039C12.5852 4 13.0615 4.85208 12.6471 5.50874L8.84339 11.5369Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpFill);
export default __webpack_public_path__ + "static/media/icon-up-fill.9c4d611496fdfb6620b0b6b8bb1d91c0.svg";
export { ForwardRef as ReactComponent };